// extracted by mini-css-extract-plugin
export default {"userInfo":"style_userInfo__BMT25","userName":"style_userName__amAlY","userEmail":"style_userEmail__+v8CN","tableBlock":"style_tableBlock__SpURu"};